export default {
  SET_TICKET_STATUS(state, payload) {
    state.ticket_statuses = payload
  },
  SET_TICKET_GROUP(state, payload) {
    state.ticket_groups = payload
  },
}
